import { useFaireDirectFirstOrderIncentive } from "@faire/deprecated-retailer-visitor-shared/hooks/FaireDirect/useFaireDirectFirstOrderIncentive/useFaireDirectFirstOrderIncentive";
import { EmailAddressField } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/_components/fields/personalFields";
import { EMAIL_UNAVAILABLE_ERROR } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/personal/__internal__/useServerValidatePersonalInfo";
import { Core } from "@faire/design-tokens";
import brandPage from "@faire/web-api--source/routes/www/brand/brandToken";
import homePage from "@faire/web-api--source/routes/www/root";
import { Button } from "@faire/web/slate/Button/Button";
import { Column } from "@faire/web/slate/Layout";
import { Span, Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import { ErrorMessage } from "formik";
import React, { useCallback, type JSX } from "react";

export const FaireDirectEmailAddressField: React.FC<
  React.ComponentProps<typeof EmailAddressField>
> = ({ trackChange }) => {
  const { brandToken } = useFaireDirectFirstOrderIncentive();

  const LinkFormatting = useCallback(
    (chunks: JSX.Element) => (
      <Button
        tertiaryColor="inherit"
        variant="tertiary"
        style={{ display: "inline" }}
        linkTo={homePage({
          signIn: "1",
          redirectTo: brandPage(brandToken ?? ""),
        })}
      >
        <Span color="inherit" variant="labelSansRegular">
          {chunks}
        </Span>
      </Button>
    ),
    [brandToken]
  );

  return (
    <Column>
      <EmailAddressField trackChange={trackChange} blockErrorMsg />
      <ErrorMessage
        name="email_address"
        render={(errorMessage) => (
          <Typography color={Core.text.critical} variant="labelSansRegular">
            {errorMessage === EMAIL_UNAVAILABLE_ERROR ? (
              <StrictLocalMsg
                id="zLdzMx"
                defaultMessage="An account with this email already exists. <LinkFormatting>Sign in</LinkFormatting>"
                description={{
                  text: "Error message for email already exists",
                  img: "https://cdn.faire.com/fastly/ea9d789e700bc43728decb8b5940cd554f070e5fa7de73366d10491f05c9920a.png",
                }}
                values={{ LinkFormatting }}
              />
            ) : (
              errorMessage
            )}
          </Typography>
        )}
      />
    </Column>
  );
};
